import { FunnelConfig } from '~/utils/funnels';

export const CONSTELLATION_FUNNEL_ID = 'constellation';

export const config: FunnelConfig = {
  id: 'constellation',
  path: '/constellation',
  show: () => true,
};
